"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BrandedAppPublishingRequestCardComponent = /*#__PURE__*/function () {
  BrandedAppPublishingRequestCardComponent.$inject = ["userService"];
  /* @ngInject */
  function BrandedAppPublishingRequestCardComponent(userService) {
    _classCallCheck(this, BrandedAppPublishingRequestCardComponent);
    this.userService = userService;
  }
  _createClass(BrandedAppPublishingRequestCardComponent, [{
    key: "$onInit",
    value: function $onInit() {
      if (!this.userCanModify) {
        return;
      }
      this.currentUserId = this.userService.getCurrentUser()._id;
      return this.checkIfAssignedToCurrentUser();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (!this.userCanModify) {
        return;
      }
      if (!changes.assignee || !changes.assignee.currentValue) {
        return;
      }
      return this.checkIfAssignedToCurrentUser();
    }
  }, {
    key: "checkIfAssignedToCurrentUser",
    value: function checkIfAssignedToCurrentUser() {
      return this.isAssignedToCurrentUser = this.assignee === this.currentUserId;
    }
  }]);
  return BrandedAppPublishingRequestCardComponent;
}();
module.exports = angular.module('backstage.components.branded-app.branded-app-publishing-request', []).component('brandedAppPublishingRequestCard', {
  templateUrl: '/src/angular/components/branded-app/branded-app-publishing-request-card/branded-app-publishing-request-card.html',
  bindings: {
    userCanModify: '<',
    publishingRequest: '<',
    assignee: '<',
    signoffUrl: '<',
    onAssign: '&',
    onUpdateStatus: '&',
    onCloseRequest: '&'
  },
  controller: BrandedAppPublishingRequestCardComponent
}).name;